module.exports = __webpack_public_path__ + "static/media/mtgEventPro.99e77692.png";